import React from 'react';
import { motion } from 'framer-motion';
export function OfferSection() {
  return <section className="px-6 pb-24 pt-12" data-id="element-86">
      <div className="max-w-2xl mx-auto text-center" data-id="element-87">
        {/* Urgency frame */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="mb-12" data-id="element-88">
          <p className="font-serif italic text-[#C4956A] text-xl md:text-2xl leading-relaxed" data-id="element-89">
            "Esta noche, cuando se apague la luz y tu cabeza empiece…
            <br data-id="element-90" />
            ¿vas a tener un protocolo o vas a repetir el loop?"
          </p>
        </motion.div>

        {/* Price card with anchoring */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16" data-id="element-91">
          <div className="inline-block relative" data-id="element-92">
            <div className="absolute inset-0 bg-[#C4956A] blur-3xl opacity-25 rounded-full" data-id="element-93"></div>
            <div className="relative bg-[#1A1815] border border-[#C4956A]/30 p-10 rounded-2xl shadow-2xl max-w-sm mx-auto" data-id="element-94">
              <p className="text-[#9B9285] text-sm uppercase tracking-widest mb-4" data-id="element-95">
                Kit R.O.O.F. Completo
              </p>

              {/* Price anchoring */}
              <div className="space-y-1 mb-4" data-id="element-96">
                <p className="text-[#9B9285]/50 text-sm" data-id="element-97">
                  1 sesión de terapia:{' '}
                  <span className="line-through" data-id="element-98">$60-120</span>
                </p>
                <p className="text-[#9B9285]/50 text-sm" data-id="element-99">
                  Valor del kit completo:{' '}
                  <span className="line-through" data-id="element-100">$53</span>
                </p>
              </div>

              <div className="text-6xl font-serif text-[#E8E0D4] mb-2" data-id="element-101">
                $6.36
              </div>
              <p className="text-[#C4956A] text-sm mb-6" data-id="element-102">
                Acceso inmediato al PDF + imprimibles
              </p>

              {/* Inline CTA */}
              <a href="https://cuerpoencalma.it.com/cart/47443462979771:1" target="_blank" rel="noopener noreferrer" className="group relative w-full inline-flex items-center justify-center px-8 py-4 text-lg font-medium text-[#0F0E0C] bg-[#C4956A] rounded-lg overflow-hidden transition-all hover:bg-[#D4A574] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#C4956A] focus:ring-offset-[#0F0E0C]" data-id="element-103">
                <span className="absolute w-0 h-0 transition-all duration-500 ease-out bg-white rounded-full group-hover:w-80 group-hover:h-80 opacity-10" data-id="element-104"></span>
                <span className="relative flex items-center gap-2" data-id="element-105">
                  Quiero el Kit R.O.O.F.
                  <motion.span animate={{
                  x: [0, 4, 0]
                }} transition={{
                  repeat: Infinity,
                  duration: 1.5
                }} data-id="element-106">
                    →
                  </motion.span>
                </span>
                <div className="absolute inset-0 rounded-lg ring-2 ring-white/20 group-hover:ring-white/40 transition-all" data-id="element-107"></div>
              </a>
              <p className="mt-3 text-xs text-[#9B9285]/60" data-id="element-108">
                Pago seguro • Descarga inmediata • Sin suscripción
              </p>
            </div>
          </div>
        </motion.div>

        {/* Closing copy */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="space-y-8 max-w-lg mx-auto" data-id="element-109">
          <div className="space-y-4 text-[#E8E0D4] text-xl leading-relaxed" data-id="element-110">
            <p data-id="element-111">No tomes decisiones permanentes con una mente en emergencia.</p>
            <p data-id="element-112">
              Empieza por algo más pequeño y más poderoso:
              <br data-id="element-113" />
              <span className="text-[#C4956A] font-serif italic text-2xl block mt-2" data-id="element-114">
                recupera el volante en 10 minutos.
              </span>
            </p>
          </div>

          {/* Final reassurance */}
          <div className="pt-6 border-t border-[#C4956A]/10" data-id="element-115">
            <p className="text-[#9B9285] text-sm leading-relaxed" data-id="element-116">
              No necesitas estar lista. No necesitas estar segura.
              <br data-id="element-117" />
              Solo necesitas dejar de negociar con el loop.
              <br data-id="element-118" />
              <span className="text-[#C4956A]" data-id="element-119">
                El kit te muestra cómo, paso a paso.
              </span>
            </p>
          </div>

          {/* Final CTA */}
          <div className="pt-4" data-id="element-120">
            <a href="https://cuerpoencalma.it.com/cart/47443462979771:1" target="_blank" rel="noopener noreferrer" className="group relative inline-flex items-center justify-center px-8 py-4 text-lg font-medium text-[#0F0E0C] bg-[#C4956A] rounded-lg overflow-hidden transition-all hover:bg-[#D4A574] hover:shadow-lg hover:shadow-[#C4956A]/25 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#C4956A] focus:ring-offset-[#0F0E0C]" data-id="element-121">
              <span className="absolute w-0 h-0 transition-all duration-500 ease-out bg-white rounded-full group-hover:w-56 group-hover:h-56 opacity-10" data-id="element-122"></span>
              <span className="relative flex items-center gap-2" data-id="element-123">
                Quiero el Kit R.O.O.F. — $6.36
                <motion.span animate={{
                x: [0, 4, 0]
              }} transition={{
                repeat: Infinity,
                duration: 1.5
              }} data-id="element-124">
                  →
                </motion.span>
              </span>
              <div className="absolute inset-0 rounded-lg ring-2 ring-white/20 group-hover:ring-white/40 transition-all" data-id="element-125"></div>
            </a>
            <p className="mt-4 text-xs text-[#9B9285]/40" data-id="element-126">
              Pago seguro • Descarga inmediata
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}